import { toPlainText } from '@portabletext/react';
import slugify from 'slugify';

export function filterDataToSingleItem(data, preview) {
    if (!Array.isArray(data)) {
        return data;
    }

    if (data.length === 1) {
        return data[0];
    }

    if (preview) {
        return data.find((item) => item._id.startsWith(`drafts.`)) || data[0];
    }

    return data[0];
}

export function generateTableOfContents(body) {
    const toc = [];
    if (!body) return toc;

    for (let i = 0; i < body.length; i++) {
        const block = body[i];
        if (block.style === 'h2') {
            toc.push({ text: toPlainText(block), id: slugify(toPlainText(block), { lower: true }) });
        }
        if (block._type === 'poiCollection') {
            toc.push({ text: block.title, id: slugify(block.title, { lower: true }) });
        }
    }
    return toc;
}

export const stripHtmlTags = (string: string): string => {
    if (!string) return string;
    return string.replaceAll(/<\/?[^>]+(>|$)/gi, '');
};
